import React, { useState, useEffect } from 'react';
import './Banner.css';

const BANNER_IMAGES = [
  '/elektrik1.jpeg', '/elektrik2.jpeg', '/elektrik3.jpeg', '/elektrik4.jpeg', '/elektrik5.jpeg',
  '/elektrik6.jpeg', '/elektrik7.jpeg', '/elektrik8.jpeg', '/elektrik9.jpeg', '/elektrik10.jpeg',
  '/elektrik11.jpeg', '/elektrik12.jpeg', '/elektrik13.jpeg', '/elektrik14.jpeg', '/elektrik15.jpeg',
  '/elektrik16.jpeg', '/elektrik17.jpeg', '/elektrik18.jpeg', '/elektrik19.jpeg', '/elektrik20.jpeg'
];

const BANNER_PHRASES = [
  'Elektrik & Elektronik',
  'Tamir ve Bakım',
  'Küçük Ev Aletleri',
  'Güvenilir Hizmet',
  'Profesyonel Çözümler',
  'Arıza Giderimi',
  'Anahtar & Kumanda',
];

const Banner = ({ direction = 'right' }) => {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const duplicated = [...BANNER_IMAGES, ...BANNER_IMAGES];
  const isLeft = direction === 'left';

  useEffect(() => {
    const t = setInterval(() => {
      setPhraseIndex((prev) => (prev + 1) % BANNER_PHRASES.length);
    }, 3800);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="banner-band" aria-label="Galeri">
      <div className={`banner-band-track ${isLeft ? 'banner-band-track--left' : ''}`}>
        {duplicated.map((img, index) => (
          <div
            key={index}
            className="banner-band-item"
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>
      <div className="banner-band-overlay" aria-hidden="true" />
      <div className="banner-band-text-wrap">
        <p key={phraseIndex} className="banner-band-phrase">
          {BANNER_PHRASES[phraseIndex]}
        </p>
      </div>
    </section>
  );
};

export default Banner;
